import React from 'react';
import { TouchableOpacity, StyleSheet, GestureResponderEvent, StyleProp, ViewStyle, TextStyle } from 'react-native';
import { fonts } from "../styles/theme";
import AppText from "./AppText";

interface CommonButtonProps {
  title: string; 
  onPress: (event: GestureResponderEvent) => void; 
  style?: StyleProp<ViewStyle>; 
  textStyle?: StyleProp<TextStyle>; 
}

const CommonButton: React.FC<CommonButtonProps> = ({ title, onPress, style, textStyle }) => {
  return (
    <TouchableOpacity style={[styles.button, style]} onPress={onPress}>
      <AppText style={[styles.text, textStyle]}  testID="button-text">{title} </AppText>
    </TouchableOpacity>
  );
};

const styles = StyleSheet.create({
  button: {
    borderRadius: 15,
    paddingVertical: 10, 
    paddingHorizontal: 20, 
    alignItems: 'center', 
    justifyContent: 'center', 
    width:"100%"
  },
  text: {
    color: '#FFFFFF', 
    fontSize: 16,
    //fontWeight: '600', 
    fontFamily: fonts.medium
  }});

export default CommonButton;
